module.exports = __webpack_public_path__ + "static/media/youtube.23225ace.svg";